<template>
    <footer class="footer">
        <v-container>
            <div class="d-lg-flex align-center">
                <v-img src="/images/ci.svg" contain max-width="146" class="w-100 mr-lg-56 mb-20 mb-lg-0"></v-img>
                <div>
                    <p class="mb-lg-14">
                        회사명  :  민아트프레임<span class="d-none d-lg-inline-block text-center" style="width: 42px;">|</span><br class="d-block d-lg-none">
                        주소  :  경기도 화성시 비봉면 양노로 103<span class="d-none d-lg-inline-block text-center" style="width: 42px;">|</span><br class="d-block d-lg-none">
                        대표자  : 민은홍
                    </p>
                    <p>
                        사업등록번호 : 108-05-82640<span class="d-none d-lg-inline-block text-center" style="width: 42px;">|</span><br class="d-block d-lg-none">
                        전화번호 : 031-465-9088<span class="d-none d-lg-inline-block text-center" style="width: 42px;">|</span><br class="d-block d-lg-none">
                        팩스번호 : 031-465-9098<span class="d-none d-lg-inline-block text-center" style="width: 42px;">|</span><br class="d-block d-lg-none">
                        이메일  :  minart369@naver.com
                    </p>
                </div>
            </div>
        </v-container>
    </footer>
</template>

<script>
import api from "@/api";

export default {
    components: {
    },
    data() {
        return {
            setting: null,
        };
    },
    computed: {
        info() {
            return this.setting?.footer?.info || [];
        },
        sns() {
            return (this.setting?.footer?.sns || []).filter(({ shows }) => shows);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const { setting } = await api.v1.setting.get();
            this.setting = setting;
        },
    },
};
</script>

<style scoped>
.footer {
    border-top: 1px solid #ddd;
    background-color: #fff;
    color: #777;
    padding: 40px 0;
    font-size: 1.2rem;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .footer {
        padding: 80px 0;
        font-size: 1.6rem;
        line-height: 1;
    }
}
@media (min-width: 1200px) {
}
</style>
